import { useContext, lazy, Suspense, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import { useTranslation } from 'react-i18next';

import Notify from './Notify/Notify';
import FTTHOTP from './FTTHOTP/FTTHOTP';
import Loading from '../components/Loading/Loading';
import FTTHSuccess from './FTTHSuccess/FTTHSuccess';

import InfoModal from '../components/InfoModal/InfoModal';
import AlertModal from '../components/AlertModal/AlertModal';
import ContactUsModal from '../components/ContactUsModal/ContactUsModal';
import RegConfirmModal from '../components/RegConfirmModal/RegConfirmModal';
import OtherOperatorModal from '../components/OtherOperatorModal/OtherOperatorModal';
import InstallationRegModal from '../components/InstallationRegModal/InstallationRegModal';

import { createShoppingCart, shoppingCartStructure, shoppingCartUpdateAndValidate } from '../api/api';
import './Pages.scss';

const Home = lazy(() => import('./Home/Home'));

function Pages() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { loading, rtl, page, popup, shoppingCart } = state;
    const { t } = useTranslation();

    const [coveredFiber, setCoveredFiber] = useState<any>(null)
    const [otherOperator, setOtherOperator] = useState<any>(null)

    const handleHeaderCancel = () => {
        dispatch({ type: 'UPDATE_POPUP', payload: '' });
    }

    const handleRegisterInterest = async (requestFlow: string = 'demand') => {
        dispatch({ type: 'UPDATE_POPUP', payload: '' })
        try {
            dispatch({ type: 'SET_LOADER', payload: true })
            const res = await createShoppingCart(requestFlow);
            const updateRes = await shoppingCartUpdateAndValidate(res?.data?.id)
            const updatedShoppingCart = {
                ...shoppingCart,
                context: {
                    ...shoppingCart.context,
                    ...updateRes?.data
                }
            }
            const structure = await shoppingCartStructure(updatedShoppingCart)
            updatedShoppingCart.context.sections = structure?.data?.sections ? structure.data.sections : [];
            dispatch({ type: 'UPDATE_SHOPPING_CART', payload: updatedShoppingCart })
            dispatch({ type: 'UPDATE_CHECKOUT_STRUCTURE', payload: structure.data })
            dispatch({ type: 'UPDATE_PAGE', payload: 'notify' })
            dispatch({ type: 'UPDATE_REQUEST_FLOW', payload: requestFlow })
            dispatch({ type: 'SET_LOADER', payload: false })
        } catch (err) {
            dispatch({ type: 'SET_LOADER', payload: false })
        }
    }

    const modalFirstButtonClick = () => {
        setCoveredFiber(null);
        setOtherOperator(null);
    }

    return (
        <div className='FTTH__Pages'>
            {page === 'map' && (
                <Suspense fallback={<Loading loading={true} />}>
                    <Home
                        setCoveredFiber={setCoveredFiber}
                        setOtherOperator={setOtherOperator}
                    />
                </Suspense>
            )}

            {page === 'notify' && (
                <Notify />
            )}

            {page === 'otp' && (
                <FTTHOTP />
            )}

            {page === 'success' && (
                <FTTHSuccess />
            )}

            {loading && (
                <Loading loading={loading} />
            )}

            {coveredFiber && (
                <InfoModal
                    id={''}
                    rtl={rtl}
                    data={{ ODB: coveredFiber?.ODB }}
                    modalFirstButtonClick={modalFirstButtonClick}
                />
            )}

            {popup === 'demand' && (
                <RegConfirmModal
                    handleHeaderCancel={handleHeaderCancel}
                    modalFirstButtonClick={handleRegisterInterest}
                />
            )}

            {popup === 'installation' && (
                <InstallationRegModal
                    handleHeaderCancel={handleHeaderCancel}
                    modalFirstButtonClick={()=>handleRegisterInterest('installation')}
                />
            )}

            {otherOperator && (
                <OtherOperatorModal
                    id={'ftth-other-operators'}
                    rtl={rtl}
                    data={otherOperator}
                    modalFirstButtonClick={modalFirstButtonClick}
                />
            )}

            {popup === 'discard' && (
                <AlertModal
                    id={'alert-discard-modal'}
                    rtl={rtl}
                    title={t('Discard_changes')}
                    description={t('If_you_leave_now')}
                    firstButtonText={t('STAY_IN_THE_PAGE')}
                    secondButtonText={t('DISCARD_AND_GO_BACK')}
                />
            )}
            {popup === 'mismatchId' && (
                <AlertModal
                    id={'alert-mismatch-modal'}
                    rtl={rtl}
                    title={t('Please_use_your_Absher_number')}
                    description={t('Mismatch_ID_description')}
                    firstButtonText={t('Got_it')}
                />
            )}

            {popup === 'notregistered' && (
                <ContactUsModal
                    id={'notregistered'}
                    rtl={rtl}
                    title={t('This_address_is_not_registered_under_your_ID')}
                    description={t('Address_not_registered_description')}
                    firstButtonText={t('Got_it')}
                />
            )}

            {popup === 'existingReq' && (
                <ContactUsModal
                    id={'existingReq'}
                    rtl={rtl}
                    title={t('There_is_an_existing_request_for_this_national_address')}
                    description={t('There_is_an_existing_request_for_this_national_address_description')}
                    firstButtonText={t('Got_it')}
                    secondButtonText={t('CONTACT_US')}
                />
            )}

            {popup === 'somethingWrong' && (
                <ContactUsModal
                    id={'somethingWrong'}
                    rtl={rtl}
                    title={t('Something_went_wrong')}
                    description={t('Something_went_wrong_description')}
                    firstButtonText={t('TRY_AGAIN')}
                    secondButtonText={t('CONTACT_US')}
                />
            )}
        </div>
    )
}

export default Pages